import { render } from "./FactoryCustomerDashboard.vue?vue&type=template&id=55724dcd&scoped=true"
import script from "./FactoryCustomerDashboard.vue?vue&type=script&lang=js"
export * from "./FactoryCustomerDashboard.vue?vue&type=script&lang=js"

import "./FactoryCustomerDashboard.vue?vue&type=style&index=0&id=55724dcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55724dcd"]])

export default __exports__